import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = { storePath: String }

  addAssignment = (event) => {
    const assignmentId = event.currentTarget.dataset.assignmentId
    const assignmentType = event.currentTarget.dataset.assignmentType

    this.storeData(assignmentType, assignmentId)
  }

  removeAssignment(event) {
    const assignmentId = event.currentTarget.dataset.assignmentId
    const assignmentType = event.currentTarget.dataset.assignmentType

    this.storeData(assignmentType, assignmentId, "delete")
  }

  storeData(type, id, action = "store") {
    const formData = new FormData()
    formData.append(type, id)

    if (action === "delete") {
      formData.append("delete", "1")
    }

    const path = this.storePathValue

    post(path, { body: formData, responseKind: "turbo-stream" }).catch(
      (error) => {
        console.log("Error:", error)
      },
    )
  }
}
